module.exports = __webpack_public_path__ + "img/donante-heraldo.af13b2e4.jpeg";